/*
 |--------------------------------------------------------------------------
 | Laravel Spark Bootstrap
 |--------------------------------------------------------------------------
 |
 | First, we will load all of the "core" dependencies for Spark which are
 | libraries such as Vue and jQuery. This also loads the Spark helpers
 | for things such as HTTP calls, forms, and form validation errors.
 |
 | Next, we'll create the root Vue application for Spark. This will start
 | the entire application and attach it to the DOM. Of course, you may
 | customize this script as you desire and load your own components.
 |
 */

import Vue from "vue";
import VueRx from "vue-rx";
import "es6-promise/auto";
import Echo from "laravel-echo";
Vue.component("pagination", require("laravel-vue-pagination"));
window.Pusher = require("pusher-js");

require("spark-bootstrap");
require("./bootstrap");

require("./components/bootstrap");
//import Vue2Editor from "vue2-editor";
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";
//import vueDropzone from "vue2-dropzone";
//import "vue2-dropzone/dist/vue2Dropzone.min.css";
import OnoffToggle from "vue-onoff-toggle";

import VuejsClipper from "vuejs-clipper";

import VueFileAgent from "vue-file-agent";
import VueFileAgentStyles from "vue-file-agent/dist/vue-file-agent.css";
import vUploader from 'v-uploader';



const uploaderConfig = {
  // file uploader service url
  uploadFileUrl: '/file?_token='+ document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute("content"),
  language: "en",
  fileTypeExts: "jpeg,jpg,gif,png,tif",
  // file delete service url
  deleteFileUrl: '/file',
  // set the way to show upload message(upload fail message)
  showMessage: (vue, message) => {
    //using v-dialogs to show message
    vue.$dlg.alert(message, {messageType: 'error'});
  }
};
Vue.use(vUploader, uploaderConfig);

Vue.use(VueFileAgent);


// install vue-rx
Vue.use(VueRx);

// install vuejs-clipper
Vue.use(VuejsClipper);
Vue.use(OnoffToggle);
//Vue.component("dropzone", require("./components/new-task/dropzone.vue"));
// install vue-rx
//Vue.use(Vue2Editor);

Vue.use(VSwatches);
//Vue.use(vueDropzone);

var app = new Vue({
    el: "#spark-app",
    mixins: [require("spark")]
});

const token = localStorage.getItem("user-token");
